// document.addEventListener("DOMContentLoaded", () => {
//   // 🔥 HARD STOP: run ONLY inside product media gallery
//   const mediaGallery = document.querySelector("media-gallery");
//   if (!mediaGallery) return;

//   const gallery = mediaGallery.querySelector("slideshow-container");
//   const scroller = gallery?.querySelector("slideshow-slides");
//   const track = mediaGallery.querySelector(".custom-thumbnails__track");
//   const variantRadios = document.querySelectorAll(
//     ".variant-picker-form input[type='radio']"
//   );

//   if (!gallery || !scroller || !track) return;

//   function getSlides() {
//     return Array.from(scroller.querySelectorAll("slideshow-slide"));
//   }

//   function buildThumbnails() {
//     track.innerHTML = "";

//     const slides = getSlides();

//     slides.forEach(slide => {
//       const img = slide.querySelector("img");
//       if (!img) return;

//       const btn = document.createElement("button");
//       btn.className = "custom-thumbnail";
//       btn.innerHTML = `<img src="${img.src}" alt="">`;

//       btn.addEventListener("click", () => {
//         slide.scrollIntoView({
//           behavior: "smooth",
//           inline: "center",
//           block: "nearest"
//         });
//       });

//       track.appendChild(btn);
//     });
//   }

//   // Initial build
//   buildThumbnails();

//   // Rebuild AFTER variant updates gallery
//   variantRadios.forEach(radio => {
//     radio.addEventListener("change", () => {
//       setTimeout(buildThumbnails, 200);
//     });
//   });
// });



// document.addEventListener("DOMContentLoaded", async () => {
//   const root = document.querySelector("#custom-thumbnails-root");
//   if (!root) return;

//   const track = root.querySelector(".custom-thumbnails__track");

//   const productHandle = window.location.pathname.split("/products/")[1];
//   if (!productHandle) return;

//   const product = await fetch(`/products/${productHandle}.js`).then(r => r.json());

//   let lastVariantId = null;

//   function getVariantId() {
//     const params = new URLSearchParams(window.location.search);
//     return params.get("variant") || product.variants[0].id.toString();
//   }

//   function getImagesForVariant(variantId) {
//     const variant = product.variants.find(v => v.id == variantId);
//     if (!variant) return [];

//     const color = variant.option1?.toLowerCase();

//     return product.media.filter(m =>
//       m.media_type === "image" &&
//       (!color || m.alt?.toLowerCase().includes(color))
//     );
//   }

//   function buildThumbnails() {
//     const variantId = getVariantId();
//     if (variantId === lastVariantId) return;
//     lastVariantId = variantId;

//     const images = getImagesForVariant(variantId);
//     if (!images.length) return;

//     track.innerHTML = "";

//     images.forEach(img => {
//       const btn = document.createElement("button");
//       btn.className = "custom-thumbnail";
//       btn.innerHTML = `<img src="${img.src}" alt="">`;

//       btn.addEventListener("click", () => {
//         const realThumb = document.querySelector(
//           `[data-media-id="${img.id}"]`
//         );

//         if (realThumb) {
//           realThumb.click();
//         }
//       });


//       track.appendChild(btn);
//     });
//   }

//   buildThumbnails();

//   let lastURL = location.href;
//   setInterval(() => {
//     if (location.href !== lastURL) {
//       lastURL = location.href;
//       buildThumbnails();
//     }
//   }, 200);
// });



document.addEventListener("DOMContentLoaded", async () => {
  const root = document.querySelector("#custom-thumbnails-root");
  if (!root) return;

  const track = root.querySelector(".custom-thumbnails__track");
  if (!track) return;

  const productHandle = window.location.pathname.split("/products/")[1];
  if (!productHandle) return;

  const product = await fetch(`/products/${productHandle}.js`).then(r => r.json());

  let lastVariantId = null;

  function getVariantId() {
    const params = new URLSearchParams(window.location.search);
    return params.get("variant") || product.variants[0].id.toString();
  }

  function normalize(str) {
    return str?.toLowerCase().trim();
  }

  function getImagesForVariant(variantId) {
    const variant = product.variants.find(v => v.id == variantId);
    if (!variant) return [];

    const color = variant.option1;
    if (!color) return [];

    const expectedAlt = `color_${normalize(color)}`;

    return product.media.filter(m => {
      if (m.media_type !== "image") return false;

      const alt = normalize(m.alt);
      return alt === expectedAlt;
    });
  }

  function buildThumbnails() {
    const variantId = getVariantId();
    if (variantId === lastVariantId) return;
    lastVariantId = variantId;

    const images = getImagesForVariant(variantId);
    if (!images.length) return;

    track.innerHTML = "";

    images.forEach(img => {
      const btn = document.createElement("button");
      btn.className = "custom-thumbnail";
      btn.innerHTML = `<img src="${img.src}" alt="">`;

      btn.addEventListener("click", () => {
        const realThumb = document.querySelector(
          `[data-media-id="${img.id}"]`
        );

        if (realThumb) {
          realThumb.click();
        }
      });

      track.appendChild(btn);
    });
  }

  buildThumbnails();

  let lastURL = location.href;
  setInterval(() => {
    if (location.href !== lastURL) {
      lastURL = location.href;
      buildThumbnails();
    }
  }, 200);
});

